import React from 'react';
import './style.css';

export default function EditButton(props){
  return(
    <button className={'EditButton ' + props.className} style={props.style} onClick={props.onClick}>
      {props.children}
    </button>
  )
}